import styled from "styled-components";

export const StyledTableBody = styled.tbody`
	border: none;
`;
